module.exports = __webpack_public_path__ + "static/media/1001597DO.22f50e8a.jpg";